import React from 'react';
export function AboutMe() {
  const funFacts = ['Entrepreneur (x5) ⚡️', 'Toddler Dad (x2) 💙💜', 'AI-obsessed builder 🤖🛠️', 'Design and product craft nerd 🎨', 'In love with strength training and all things wellness 💪🏻', 'Born in 🇨🇦, living in 🇺🇸 (dual citizen)'];
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1">
      {/* Main content - 2/3 width */}
      <div className="md:col-span-2 space-y-4 text-slate-700 leading-relaxed print:text-black" data-id="element-2">
        <p data-id="element-3">At my core, I'm a builder.</p>
        <p data-id="element-4">
          I've spent my life creating companies, products, and teams, and I'm at
          my best when the path forward isn't obvious. I love early-stage
          problems, and I care just as much about what happens after launch,
          when small decisions start to compound into real impact.
        </p>
        <p data-id="element-5">
          I'm also a dad of two young kids, which has quietly become one of the
          most meaningful leadership experiences of my life. It's made me more
          patient, more intentional with my time, and more focused on building
          things that are genuinely useful in the real world.
        </p>
        <p data-id="element-6">
          I'm deeply interested in how AI can increase leverage for product
          teams, not by replacing judgment, but by tightening feedback loops and
          helping people move faster with clarity and confidence.
        </p>
        <p className="font-medium text-slate-900 print:text-black" data-id="element-7">
          If there's a throughline to everything I do, it's this: I care about
          building thoughtful, human products, and doing it with people I
          genuinely enjoy working with.
        </p>
      </div>

      {/* Fun facts sidebar - 1/3 width */}
      <div className="md:col-span-1" data-id="element-8">
        <div className="bg-slate-50 border-l-2 border-blue-600 p-6 rounded-r-lg print:bg-transparent print:border-black" data-id="element-9">
          <h3 className="text-sm font-bold tracking-[0.2em] uppercase text-slate-400 mb-4 print:text-black" data-id="element-10">
            Quick Facts
          </h3>
          <ul className="space-y-3" data-id="element-11">
            {funFacts.map((fact, idx) => <li key={idx} className="text-sm text-slate-700 print:text-black" data-id="element-12">
                {fact}
              </li>)}
            <li className="text-sm text-slate-700 pt-2 border-t border-slate-200 print:text-black print:border-black" data-id="element-13">
              <strong className="text-slate-900 print:text-black" data-id="element-14">
                Fun fact:
              </strong>{' '}
              I've lived abroad on three different continents (🇦🇹 Austria, 🇲🇾
              Malaysia, 🇨🇱 Chile)
            </li>
          </ul>
        </div>
      </div>
    </div>;
}